var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"like-icon",on:{"click":_vm.like}}),_c('span',[_vm._v(_vm._s(_vm.likeNum))])])}
var staticRenderFns = []

export { render, staticRenderFns }